import {
  CreateCCParams,
  StripeTokenResponse,
} from '../types/payment-strategy.types';
import {
  buildCommonCC,
  goToProcessing,
  stripeErrorToMessage,
} from '../utils/cc-utils';
import { emitUtmifyEvent } from '../utils/emitUtmifyEvent';

export const cardStripeStrategy = async ({
  data,
  checkout,
  id,
  api,
  gerarTokenRecaptcha,
  navigate,
  location,
  getUrlParams,
  paymentMethod,
}: any) => {
  const recaptcha = await gerarTokenRecaptcha(`/venda`);
  const afiliadoId = getUrlParams('affiliate') ?? undefined;

  const payload: CreateCCParams = {
    metodoPagamento: paymentMethod,
    produtoId: id ?? '',
    ...buildCommonCC(data),
    token: data.card!.token,
    checkoutId: checkout?.id,
    recaptchaToken: recaptcha,
    installments: 1,
    afiliadoId,
    cpfComprador: undefined,
  };

  const purchase = await api.Venda.createCC(payload);
  const { card, ...safeContract } = data;
  emitUtmifyEvent({
    event: 'waiting_payment',
    vendaId: purchase.data?.id,
  });
  goToProcessing(navigate, location.search, purchase, checkout, safeContract);
};
